module.exports = __webpack_public_path__ + "img/2021-03-31_13-34-30.4a409102.jpg";